import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserService } from './user.service';

@Injectable()
export class UserInterceptor implements HttpInterceptor {
    constructor(private userService: UserService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        let authRequest;    
            //const authToken = this.userService.getToken();
            const userId = this.userService.getUserEmail();
            const userName = this.userService.getUserName();   
            const authToken = 'sssssrrwrwxcrcrewrewrcwererwe';
            authRequest = req.clone({
                headers: req.headers.set("Authorization", "Bearer " + authToken),
                body: {...req.body, createdBy: userId +' ('+ userName+')' }
            }); 
        return next.handle(authRequest);
    }
}